import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Convert a title string into a URL-friendly slug.
 * "Why Does God Allow Suffering?" → "why-does-god-allow-suffering"
 */
export function slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/[''"]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .substring(0, 80);
}

/**
 * Ensure a slug is unique in Firestore. If taken, appends -2, -3, etc.
 * Use this for user-provided or pre-slugified slugs.
 * @param {string} slug - Preferred slug
 * @param {string} [excludeArticleId] - If the slug is taken by this article ID, allow it (for edits).
 */
export async function ensureUniqueSlug(slug, excludeArticleId) {
  const base = (slug && slugify(slug)) || '';
  if (!base) return null;

  let candidate = base;
  let suffix = 2;

  while (true) {
    const q = query(
      collection(db, 'articles'),
      where('slug', '==', candidate)
    );
    const snap = await getDocs(q);

    if (snap.empty) return candidate;
    if (excludeArticleId && snap.docs.some(d => d.id === excludeArticleId)) return candidate;

    candidate = `${base}-${suffix}`;
    suffix++;

    if (suffix > 20) {
      return `${base}-${Date.now().toString(36)}`;
    }
  }
}

/**
 * Generate a unique slug from a title (slugifies then ensures unique).
 * Use when you don't have a user-entered slug.
 */
export async function generateUniqueSlug(title) {
  const base = slugify(title);
  return base ? ensureUniqueSlug(base) : null;
}
